import { render } from "./px-list-header.vue?vue&type=template&id=4c73a980&scoped=true&ts=true"
import script from "./px-list-header.vue?vue&type=script&lang=ts"
export * from "./px-list-header.vue?vue&type=script&lang=ts"

import "./px-list-header.vue?vue&type=style&index=0&id=4c73a980&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c73a980"]])

export default __exports__